import { Component, OnInit, Input, EventEmitter, Output, OnDestroy, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { PartnerRelationship } from '../../models/PartnerRelationship';
import { Person } from '../../models/Person';
import { PartnerService } from '../../partner-service';
import { Subscription, Subject } from 'rxjs';
import { RelationshipDataItem } from '../../models/partner';
import { PartnershipService } from '../../partnership.service';
import { PrivilegeService } from '../../privilege.service';
import { Privilege } from '../../models/UserRelationship';

@Component({
  selector: 'app-partner-details',
  templateUrl: './partner-detail.component.html',
  styleUrls: ['./partner-detail.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class PartnerDetailComponent implements OnInit, OnDestroy, OnChanges {
    @Input() readOnly: boolean;
    @Input() relationshipId: number;
    @Input() refresh: boolean;
    @Output() onChange = new EventEmitter<PartnerRelationship>();
    @Output() onAssetGroupChange = new EventEmitter<any>();
    @Output() onSelectPartner = new EventEmitter<string>();
    @Output() onPrivilegeChange = new EventEmitter<any>();
    relationshipXrefId: number;
    partnerRelationship: PartnerRelationship;
    partnerStatus: any[];
    availableGroup: RelationshipDataItem[];
    selectedGroup: RelationshipDataItem[];
    primaryContactPersons: Person[];
    primaryContactSelected: Person;
    currentPartnerStatus: any;
    assetGroupItemId: string[];
    subscription: Subscription;
    assetGroupLoading = false;
    searchInput: string;
    assetIdSearch: Subject<string> = new Subject<string>();
    assetIdCount = 0;
    relationshipTypePrivileges: Privilege[] = [];
    selectedItemsNow: any[] = [];
    privilegesAssigned: Privilege[] = [];
    partnershipTypePrivileges: any[] = [];

    constructor(private partnerSvc: PartnerService, private partnershipSvc: PartnershipService,
        private partnerPrivilegeSvc: PrivilegeService) { }

    ngOnInit() {
        this.partnerStatus = [
            {name: 'Active', value: 'true'},
            {name: 'Inactive', value: 'false'}
        ];
        this.populatePartnerRelationship(this.relationshipId);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.refresh.currentValue) {
            this.populatePartnerRelationship(this.relationshipId);
        }
    }

    populatePartnerRelationship(id: number): void {
        this.relationshipXrefId = id;
        this.subscription = this.partnershipSvc.findById(this.relationshipXrefId)
            .subscribe(partners => {
                this.partnerRelationship = (<any>partners).data[0];
                this.partnerPrivilegeSvc.findByRelationshipTypeID(this.partnerRelationship.RelationshipType.RelationshipTypeId)
                    .subscribe((relationshipTypePrivilege) => {
                        this.partnershipTypePrivileges = (<any>relationshipTypePrivilege).data;
                        // retrieving unique Partnership Type privileges based on groups privileges and privileges
                        this.relationshipTypePrivileges = this.partnerSvc.getUniquePrivileges(
                            this.partnershipTypePrivileges[0].PrivilegeGroups,
                            this.partnershipTypePrivileges[0].Privileges);
                        // retrieving unique Partnership privileges based on groups privileges and privileges
                        this.privilegesAssigned = this.partnerSvc.getUniquePrivileges(
                            this.partnerRelationship.PrivilegeGroups,
                            this.partnerRelationship.Privileges);
                            // retrieving all the assigned privileges for current Partnership
                            this.privilegesAssigned = this.partnerPrivilegeSvc.findByStatus(this.privilegesAssigned, true);
                    });
                this.currentPartnerStatus = this.partnerRelationship.IsActive ?
                    { name: 'Active', value: 'true' } : { name: 'Inactive', value: 'false' };
                this.splitAvailableandSelectedGroups(this.partnerRelationship.MasterDataKeys);
                this.primaryContactPersons = this.partnerRelationship.PartnerUser.map((Persons, index) => {
                    this.primaryContactSelected = Persons.IsPrimary ? Persons.Person : this.primaryContactSelected;
                    return Persons.Person;
                });
                if (!this.readOnly) { this.assetGroupSearch(); }
                this.addFullName(this.primaryContactPersons);
                this.onChange.emit(this.partnerRelationship);
                this.onAssetGroupChange.emit(this.selectedGroup);
                this.onSelectPartner.emit(this.partnerRelationship.ChildCompany.Name);
            });
    }

    assetGroupSearch() {
        this.searchInput = this.partnerRelationship.ChildCompany.Name.slice(0, 5);
        this.subscription = this.partnerSvc
            .assetGroupSearchObservable(this.assetIdSearch, this.partnerRelationship.RelationshipType)
            .subscribe((res: any)  => {
                this.assetIdCount = (res.meta.pagination.TotalRecords) ? res.meta.pagination.TotalRecords : 0;
                this.availableGroup = res.data;
                this.availableGroup = this.availableGroup.filter((available: RelationshipDataItem) => {
                    return this.selectedGroup.map((selected) => selected.ItemId).indexOf(available.ItemId) === -1;
                });
                this.assetGroupLoading = false;
            });
        this.assetIdSearch.next(this.searchInput);
        this.assetGroupLoading = true;
    }

    addFullName(PrimaryContactPersons: Person[]): void {
        PrimaryContactPersons.map((person, index) => {
            PrimaryContactPersons[index].FullName = (PrimaryContactPersons[index].FirstName ? PrimaryContactPersons[index].FirstName : '')
             + ' ' + (PrimaryContactPersons[index].LastName ? PrimaryContactPersons[index].LastName : '');
            });
    }

    splitAvailableandSelectedGroups(MasterDataKeys: RelationshipDataItem[]): void {
        this.selectedGroup = [];
        this.assetGroupItemId = [];
        MasterDataKeys.map((group, index) => {
            this.updateMasterGroup(group);
        });
        this.partnerRelationship.MasterDataKeys = this.selectedGroup;
    }

    updateMasterGroup(group: RelationshipDataItem) {
        if (group.ItemIncluded) {
            this.selectedGroup.push(group);
            this.assetGroupItemId.push(group.ItemId);
        }
    }

    masterGroupChange(group: RelationshipDataItem[]): void {
        this.selectedGroup = group;
        this.onAssetGroupChange.emit(this.selectedGroup);
        this.partnerRelationship.MasterDataKeys = group;
        this.onChange.emit(this.partnerRelationship);
    }

    partnerStatusChange(): void {
        this.partnerRelationship.IsActive = this.currentPartnerStatus.value;
        this.onChange.emit(this.partnerRelationship);
    }

    ParterNameChange(): void {
        this.onChange.emit(this.partnerRelationship);
    }

    searchTextInput(value): void {
        this.assetIdSearch.next(value);
    }

    primaryContactChange(): void {
        this.partnerRelationship.PartnerUser.map((Persons, index) => {
            this.partnerRelationship
            .PartnerUser[index].IsPrimary = (Persons.Person.PersonId === this.primaryContactSelected.PersonId) ? true : false;
        });
        this.onChange.emit(this.partnerRelationship);
    }

    privilegeChange(privilege): void {
        this.selectedItemsNow = privilege.Privileges;
        // set timeout() is in place cause of this error "Expression has changed after it was checked"
        setTimeout(() => {
        // update partnership if privilege dropdown returns value
            if (this.selectedItemsNow.length > 0) {
                this.partnerRelationship.PartnerUser[0].Privileges = this.selectedItemsNow;
                this.partnerRelationship.Privileges = this.selectedItemsNow;
                this.onChange.emit(this.partnerRelationship);
            }
            this.onPrivilegeChange.emit(this.selectedItemsNow);
        });
    }

    privilegeList(privileges: Privilege[]): string {
        const aData: any = [];
        if (privileges !== undefined && privileges.length) {
          privileges.map((privilege) => aData.push(privilege.PrivilegeName));
        }
        return aData.join(', ');
      }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
